import { t } from 'ttag'

import { Text } from '@h2/components/typography/text'

import { ActivityItem } from './activityItem'

const ActivtyList = ({ items = [] }) => {
  if (!items.length) {
    return (
      <Text size="small" align="center">
        {t`No recent activity yet.`}
      </Text>
    )
  }

  return items.map((item, index) => <ActivityItem item={item} key={index} />)
}

export { ActivtyList }
